<template>
    <div class="container pt-2">
        <PageTitle main="Relatório de Transportes por Motorista e Período" sub="" />
        <div class="row">
                <div class="col-md-4">
                    <b-form-group label="Motorista:" label-for="motorista">
                        <b-form-select id="motorista" :options="motoristas"
                            v-model="temp.id"
                            placeholder="Informe o nome do motorista."
                            class="textInput"/>
                    </b-form-group>
                </div>
                <div class="col-md-4">
                    <b-form-group label="Data Inicial:" label-for="inicio">
                        <Datepicker 
                        :language="ptBR" 
                        :bootstrap-styling="true"
                        v-model="temp.inicio" 
                        id="inicio"
                        @selected="loadMotorista">
                        </Datepicker>
                    </b-form-group>
                </div>
                <div class="col-md-4">
                    <b-form-group label="Data Final" label-for="final">
                        <Datepicker 
                        :language="ptBR" 
                        :bootstrap-styling="true"
                        v-model="temp.final"
                        id="final"
                        @selected="loadMotorista">
                        </Datepicker>
                    </b-form-group>
                </div>
            </div>
        <div class="row justify-content-md-center" v-if="isLoading">
            <b-spinner variant="success" label="Spinning"></b-spinner>
        </div>
        <b-button variant="success" block class="mt-2 mb-2 botaoInput" @click="callReport" v-if="!visualizaReport && !isLoading">Gerar Relatório</b-button>
        <hr v-if="!visualizaReport">
        <b-button variant="warning" block class="mt-2 mb-2 botaoInput" :href="link" v-if="visualizaReport">Salvar</b-button>
        <hr v-if="visualizaReport">
        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <b-table 
                hover 
                striped 
                id="table-transportes" 
                class="text-center table table-sm" 
                :items="transportes.length>0?transportes:[]" 
                :fields="fields">
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
        </div>
        <div v-else>
            <b-table 
                hover 
                striped 
                id="table-transportes" 
                class="text-center table table-sm" 
                :items="transportes.length>0?transportes:[]" 
                :fields="fields" >
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import Datepicker from 'vuejs-datepicker'
import { ptBR } from 'vuejs-datepicker/dist/locale'

export default {
    name: 'TransportesByMotorista',
    components: { PageTitle, Datepicker },
    data: function() {
        return {
            larguraTela: 0,
            ptBR: ptBR,
            overflowValue: 'auto',
            visualizaReport: false,
            isLoading: false,
            link: '',
            motorista: {},
            motoristas: [],
            rep: {},
            temp: {},
            exibeRodape: true,
            transportes: [],
            fields: [
                { key: 'rastreio', label: 'Rastreio', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'data_inicio', label: 'Início', sortable: true, formatter: 'formatData', thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'data_final', label: 'Previsão', sortable: true, formatter: 'formatData', thClass: 'tituloTabela', tdClass: 'fieldsTabela' }
            ]
        }
    },
    methods: {
        formatData(value) {
            const arr = value.split('-')
            const y = arr[0]
            const m = arr[1]
            const d = arr[2]
            return `${d}/${m}/${y}`
        },
        loadTransportes(nome) {
            const inicio = new Date(this.temp.inicio)
            const Idia  = inicio.getDate().toString()
            const IdiaF = (Idia.length == 1) ? '0'+Idia : Idia
            const Imes  = (inicio.getMonth()+1).toString() //+1 pois no getMonth Janeiro começa com zero.
            const ImesF = (Imes.length == 1) ? '0'+Imes : Imes
            const IanoF = inicio.getFullYear()

            const dataInicio = IanoF + '-' + ImesF + '-' + IdiaF

            const final = new Date(this.temp.final)
            const Fdia  = final.getDate().toString()
            const FdiaF = (Fdia.length == 1) ? '0'+Fdia : Fdia
            const Fmes  = (final.getMonth()+1).toString() //+1 pois no getMonth Janeiro começa com zero.
            const FmesF = (Fmes.length == 1) ? '0'+Fmes : Fmes
            const FanoF = final.getFullYear()

            const dataFinal = FanoF + '-' + FmesF + '-' + FdiaF

            const url = `${baseApiUrl}/backend/logByMotoristaPeriodo.php?motorista=${nome}&inicio=${dataInicio}&final=${dataFinal}`
            axios.get(url).then(res => {
                this.transportes = res.data
                if(this.transportes.length > 0) {
                    this.exibeRodape = false
                }else{
                    this.exibeRodape = true
                }
            })
        },
        callReport() {
            this.isLoading = true
            const inicio = new Date(this.temp.inicio)
            const Idia  = inicio.getDate().toString()
            const IdiaF = (Idia.length == 1) ? '0'+Idia : Idia
            const Imes  = (inicio.getMonth()+1).toString() //+1 pois no getMonth Janeiro começa com zero.
            const ImesF = (Imes.length == 1) ? '0'+Imes : Imes
            const IanoF = inicio.getFullYear()

            const dataInicio = IanoF + '-' + ImesF + '-' + IdiaF

            const final = new Date(this.temp.final)
            const Fdia  = final.getDate().toString()
            const FdiaF = (Fdia.length == 1) ? '0'+Fdia : Fdia
            const Fmes  = (final.getMonth()+1).toString() //+1 pois no getMonth Janeiro começa com zero.
            const FmesF = (Fmes.length == 1) ? '0'+Fmes : Fmes
            const FanoF = final.getFullYear()

            const dataFinal = FanoF + '-' + FmesF + '-' + FdiaF

            const url = `${baseApiUrl}/backend/repTransportesByMotoristaAndPeriodo.php?motorista=${this.motorista.id}&motorista_nome=${this.motorista.nome}&inicio=${dataInicio}&final=${dataFinal}`
            axios.get(url).then((res) => {
                this.isLoading = false
                this.visualizaReport = true
                this.link = res.data['result']
            })
        },
        loadMotoristas() {
            const url = `${baseApiUrl}/backend/motoristas.php`
            axios.get(url).then(res => {
                if(res.data['dados']!=='Não há dados disponíveis'){
                    this.motoristas = res.data.map(motorista => {
                        return { ...motorista, value: motorista.id, text: motorista.nome }
                    })
                }else{
                    this.motoristas.push({ value: 'null', text: 'Não há dados disponíveis' })
                }
            })
        },
        loadMotorista() {
            const url = `${baseApiUrl}/backend/motoristas.php?id=${this.temp.id}`
            axios.get(url).then(res => {
                this.motorista = res.data[0]
                this.loadTransportes(this.motorista.nome)

            })
        }
    },
    mounted() {
        this.loadMotoristas()
        this.exibeRodape = true
        this.visualizaReport = false
        this.larguraTela = screen.width - (screen.width * 0.08)
    }
}
</script>

<style>
.textInput, #inicio, #final {
    border: 1px solid rgb(220, 220, 220);
    outline: 0 !important;
    border-radius: 0px !important;
    background-color: transparent !important;
    font-size: 0.8rem !important;
}
</style>